import script from "./trCard.vue?vue&type=script&setup=true&lang=js"
export * from "./trCard.vue?vue&type=script&setup=true&lang=js"

import "./trCard.vue?vue&type=style&index=0&id=055227b0&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-055227b0"]])

export default __exports__